export const getAdditionalInverterId = (entry) =>
  entry?.id ||
  entry?.inverter_id ||
  entry?.inverterId ||
  entry?.companyInverterID ||
  entry?.companyInverterId ||
  null;

export const normalizeAdditionalInverter = (entry, hardwareInverters = []) => {
  const inverterId = getAdditionalInverterId(entry);
  if (!inverterId) return null;

  const hardwareInverter = (
    Array.isArray(hardwareInverters) ? hardwareInverters : []
  ).find(({ id }) => String(id) === String(inverterId));
  const quantityRaw = Number(
    entry?.quantity ?? entry?.max_count ?? entry?.maxCount ?? 1
  );
  const quantity =
    Number.isFinite(quantityRaw) && quantityRaw > 0 ? quantityRaw : 1;
  const autoQuantity =
    entry?.autoQuantity !== undefined
      ? entry.autoQuantity !== false
      : entry?.auto_quantity !== false;

  const capacityFromEntry = Number(entry?.capacity);
  const capacityFromHardware = Number(hardwareInverter?.capacity);
  const resolvedCapacity =
    Number.isFinite(capacityFromEntry) && capacityFromEntry > 0
      ? capacityFromEntry
      : Number.isFinite(capacityFromHardware) && capacityFromHardware > 0
        ? capacityFromHardware
        : 0;

  return {
    ...(hardwareInverter || {}),
    ...(entry || {}),
    id: hardwareInverter?.id || inverterId,
    inverter_id: hardwareInverter?.id || inverterId,
    model: entry?.model ?? hardwareInverter?.model ?? 'Unknown',
    type: entry?.type ?? hardwareInverter?.type ?? null,
    quantity,
    autoQuantity,
    capacity: resolvedCapacity,
    efficiency: entry?.efficiency ?? hardwareInverter?.efficiency,
    max_dc_voltage: entry?.max_dc_voltage ?? hardwareInverter?.max_dc_voltage,
    max_dc_current: entry?.max_dc_current ?? hardwareInverter?.max_dc_current,
    min_mppt_voltage:
      entry?.min_mppt_voltage ?? hardwareInverter?.min_mppt_voltage,
    mppt_count_per_inverter:
      entry?.mppt_count_per_inverter ??
      hardwareInverter?.mppt_count_per_inverter,
    strings_per_mppt_max:
      entry?.strings_per_mppt_max ?? hardwareInverter?.strings_per_mppt_max,
    manufacturer_id:
      entry?.manufacturer?.name ??
      entry?.manufacturer_id ??
      hardwareInverter?.manufacturer?.name ??
      hardwareInverter?.manufacturer_id ??
      'Unknown'
  };
};

export const toPersistedAdditionalInverters = (
  additionalInverters = [],
  hardwareInverters = []
) =>
  (Array.isArray(additionalInverters) ? additionalInverters : [])
    .map((inverter) => normalizeAdditionalInverter(inverter, hardwareInverters))
    .filter((inverter) => inverter?.id)
    .map((inverter) => ({
      inverter_id: inverter.id,
      model: inverter?.model || 'Unknown',
      type: inverter?.type || null,
      capacity: Number(inverter?.capacity) > 0 ? Number(inverter.capacity) : 0,
      efficiency: inverter?.efficiency,
      max_dc_voltage: inverter?.max_dc_voltage,
      max_dc_current: inverter?.max_dc_current,
      min_mppt_voltage: inverter?.min_mppt_voltage,
      mppt_count_per_inverter: inverter?.mppt_count_per_inverter,
      strings_per_mppt_max: inverter?.strings_per_mppt_max,
      manufacturer_id:
        inverter?.manufacturer?.name || inverter?.manufacturer_id || 'Unknown',
      quantity: inverter?.quantity || 1,
      autoQuantity: inverter?.autoQuantity !== false
    }));
